import type { PaginationParams } from "@/react/types";

import { absolutePath } from "./absolutePath";

export const systemMarketingEmailTemplates = {
  index: ({ params = {} }: { params?: PaginationParams } = {}) =>
    absolutePath("system_marketing_email_templates", params),
  item: ({ id }: { id: number }) =>
    absolutePath(`system_marketing_email_templates/${id}`),
} as const;
